import { graphql } from 'gatsby'
import React from 'react'

import ContactDetailPage from '../containers/ContactPage/DetailPage'

const ContactDetail = ({ data, location }) => {
  return <ContactDetailPage {...data.portal} location={location} />
}

export default ContactDetail

export const query = graphql`
  query ContactDetailQuery ($firebaseId: String) {
    portal(firebaseId: {eq: $firebaseId}) {
      ...PartialPortalData
      ...ContactData
    }
  }
`
